import { useState } from "react";
import { MORE_FILTERS } from "../../constant";
import SelectBox from "components/elements/selectBox";

const FilterGroup = ({ item, filter = {}, setFilter, filterMoreCategory = [] }) => {
    var more_filters = MORE_FILTERS;
    if (Boolean(Object.keys(filterMoreCategory).length)) {
        filterMoreCategory.dateRange = MORE_FILTERS.dateRange;
        filterMoreCategory.region = MORE_FILTERS.region;
        more_filters = filterMoreCategory;
    }
    const [type, setType] = useState(item.defaultValue);

    return (
        <div className="d-flex flex-column">
            <label className="form-label">{item.label}</label>
            <div className="d-flex gap-3">
                <SelectBox
                    options={item.value}
                    value={type || ""}
                    placeholder={`Select ${item.label}`}
                    onChange={(data) => {
                        setType(data.value || "");
                    }}
                />
                <SelectBox
                    options={(more_filters[type] || []).map((item) => ({
                        value: item.id,
                        label: item.name,
                    }))}
                    value={filter[type] || ""}
                    placeholder={`Select ${item.label}`}
                    onChange={(data) => {
                        setFilter?.((prev) => ({
                            ...prev,
                            ...item.value.reduce((r, obj) => {
                                r[obj.value] = "";
                                return r;
                            }, {}),
                            [type]: data.value || "",
                        }));
                    }}
                />
            </div>
        </div>
    );
};

export default FilterGroup;
